import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getManufacturedComponents({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/manufactured_components`, { params })
  },
  searchManufacturedComponents({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/manufactured_components/search`, { params })
  },
  getManufacturedComponent({ commit }, id) {
    return axios.get(`/manufactured_components/${id}`)
  },
  createManufacturedComponent({ commit }, data) {
    return axios.post('/manufactured_components', data)
  },
  updateManufacturedComponent({ commit }, data) {
    return axios.put(`/manufactured_components/${data.id}`, data)
  },
  importManufacturedComponents({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    formData.append('supplier_id', params.supplierId)
    return axios.post('/manufactured_components/import', formData)
  },
}
